import { OlympusClient } from '@/OlympusClient'

export const deleteBlockHandler = async (sectionId: string): Promise<void> => {
  await OlympusClient.notifications.v1.templates.sms.sections.deleteSMSSection({
    params: { sectionId },
  })
}
